
import { axios } from '@/utils/request'

export function login(parameter) {
    return axios({
        url: '/user/login',
        method: 'post',
        data: parameter
    })
}
export function logout(logoutToken) {
    return axios({
        url: '/user/loginOut',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Access-Token':  logoutToken
        }
    })
}
